// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import JobTitleDto from 'common/dto-types/contacts/job-title-dto';

type JobTitleSliceStates = {
    data?: JobTitleDto;
    isFormOpen: boolean;
};

const initialState: JobTitleSliceStates = {
    isFormOpen: false,
};

const jobTitle = createSlice({
    name: 'jobTitle',
    initialState,
    reducers: {
        setJobTitle(state, action) {
            state.data = action.payload;
        },

        openJobTitleForm(state) {
            state.isFormOpen = true;
        },

        closeJobTitleForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
        },
    },
});

export default jobTitle.reducer;

export const { openJobTitleForm, closeJobTitleForm, setJobTitle } = jobTitle.actions;
